import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../../../hooks/useFirebaseUser.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
} from "../../../../../hooks/api/v2/apiV2Request";
import { ServerStateKeys } from "../../../../../hooks/api/v2/ServerStateKeys";

export function useSellarImportCustomFeeRemove({
  payoutId,
}: {
  payoutId: number;
}) {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (feeId: number) =>
      apiV2Request({
        user,
        business,
        method: "delete",
        path: `sellar-imports/finance/payouts/${payoutId}/custom-fees/${feeId}`,
      }).then((response) => apiV2AssertResponse<{ id: number }>(response).data),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SellarImportsPayouts,
          payoutId,
        ],
      });
    },
  });
}
